import { clsx } from 'clsx'
import { View } from 'react-native'

import { Placeholder, PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'
import { TEST_ID } from '@/src/general/constants/testId'

export const EverlastingItemPlaceholder = ({ className }: { className?: string }) => (
  <Placeholder
    className={clsx('max-w-full flex-col gap-4 pl-4', className)}
    testID={TEST_ID.PRAYER_SPACE.EVERLASTING_SLIDER_PLACEHOLDER}
  >
    <View className="w-full flex-row items-center gap-4">
      <PlaceholderMedia size="avatar-md" radius="sm" />
      <PlaceholderLine size="lg" className="flex-1" />
      <PlaceholderMedia size="avatar-sm" radius="full" />
    </View>
    <PlaceholderLine contrast="dark" className="h-24 rounded-lg" />
  </Placeholder>
)
